import axiosHelper from 'src/utils/axiosHelper';
import moment from 'moment';

export const GET_RAISED_ISSUE_LIST = '@raisedIssue/get-raised-issue-list';
export const ERROR_MSG = '@raisedIssue/error-message';
export const LOADER = '@raisedIssue/loader';
export const CLEAR_ERROR_MSG = '@raisedIssue/clear-error-message';
export const GET_RAISED_ISSUE_DETAILS = '@raisedIssue/get-raised-issue-details';
export const UPDATE_RAISED_ISSUE_STATUS =
  '@raisedIssue/update-raised-issue-status';
export const GET_RAISED_ISSUE_HISTORY = '@raisedIssue/get-raised-issue-history';
export const GET_ENTERPRISE_LIST = '@raisedIssue/get-enterprise-list';
export const GET_USER_LIST = '@raisedIssue/get-user-list';

// Raised By has exactly 2 options: selecting neither or both both mean "no
// filter" for this field, so only send a value when exactly one is chosen.
const createdByEmail = {
  Admin: 'admin@finezza.in',
  Client: 'user@finezza.in'
};

export const getRaisedIssueList = filterData => {
  const {
    reportName,
    status,
    issueIdentifier,
    reportId,
    type,
    enterpriseId,
    modifiedBy,
    createdBy,
    issueId,
    fromDate,
    toDate,
    page,
    size,
    sortBy,
    order
  } = filterData;
  let url = `/api/correction/issue`;
  const request = axiosHelper({
    url: url,
    method: 'post',
    params: {
      page,
      sortBy,
      order,
      size
    },
    data: {
      reportName,
      status:
        status && Array.isArray(status) && status.length > 0
          ? status.join(',')
          : undefined,
      type:
        type && Array.isArray(type) && type.length > 0
          ? type.join(',')
          : undefined,
      issueIdentifier,
      reportId,
      issueId,
      fromDate,
      toDate,
      enterpriseId:
        enterpriseId && Array.isArray(enterpriseId) && enterpriseId.length > 0
          ? enterpriseId.join(',')
          : undefined,
      modifiedBy:
        modifiedBy && Array.isArray(modifiedBy) && modifiedBy.length > 0
          ? modifiedBy.join(',')
          : undefined,
      createdBy:
        createdBy && Array.isArray(createdBy) && createdBy.length === 1
          ? createdBy.map(v => createdByEmail[v] || v).join(',')
          : undefined
    }
  });
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_RAISED_ISSUE_LIST,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: ERROR_MSG,
          payload: error.response && error.response.data
        });
      });
  };
};

export const getRaisedIssueDetails = issueId => {
  let url = `/api/correction/issue/${issueId}`;
  const request = axiosHelper({
    url: url,
    method: 'get'
  });
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_RAISED_ISSUE_DETAILS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: ERROR_MSG,
          payload: error.response && error.response.data
        });
      });
  };
};

export const updateRaisedIssueStatus = (issueId, status, comment) => {
  let url = `/api/correction/issue/${issueId}`;
  const request = axiosHelper({
    url: url,
    method: 'POST',
    data: {
      correctionStatus: status,
      ...(comment ? { techComment: comment } : {})
    }
  });
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: UPDATE_RAISED_ISSUE_STATUS,
          payload: response.data
        });
        if (status === 'RESOLVED') dispatch(getRaisedIssueDetails(issueId));
      })
      .catch(error => {
        dispatch({
          type: ERROR_MSG,
          payload: error.response && error.response.data
        });
      });
  };
};

export const getIssueHistory = issueId => {
  let url = `/api/correction/issue/history?id=${issueId}`;
  const request = axiosHelper({
    url: url,
    method: 'GET'
  });
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: GET_RAISED_ISSUE_HISTORY,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: ERROR_MSG,
          payload: error.response && error.response.data
        });
      });
  };
};

export const getEnterpriseList = () => {
  let url = `/api/correction/enterprise/activeIssueEnterprise`;
  const request = axiosHelper({
    url: url,
    method: 'get'
  });
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: GET_ENTERPRISE_LIST,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: ERROR_MSG,
          payload: error.response && error.response.data
        });
      });
  };
};

export const getUserList = () => {
  let url = `/api/correction/user/all/basic`;
  const request = axiosHelper({
    url: url,
    method: 'get'
  });
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: GET_USER_LIST,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: ERROR_MSG,
          payload: error.response && error.response.data
        });
      });
  };
};

export const showErrorMessage = errorMsg => {
  return dispatch => {
    dispatch({
      type: ERROR_MSG,
      payload: { message: errorMsg }
    });
  };
};

export const clearErrorMessage = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_ERROR_MSG,
      payload: null
    });
  };
};
